

$( document ).ready(function() {




   //https://b24.turbo-drive.od.ua/rest/7/zq88pbkmyxz7tf7p/crm.lead.add.json?FIELDS[TITLE]=fromquizlanding&FIELDS[PHONE][0][VALUE]=380995178127



   $('.popup-form-submit').on('click', function (){
      let phone = $(this).parent().parent().find('.wpcf7-tel').val();
      phone = phone.replace(/\D/g, '');
      if (phone.length > 5) {
         $.get("https://b24.turbo-drive.od.ua/rest/7/zq88pbkmyxz7tf7p/crm.lead.add.json?FIELDS[TITLE]=fromquizlanding&FIELDS[PHONE][0][VALUE]=" + phone, '', function(data, status) {
            if(status === 'success'){
               $('.popup-form').css('display', 'none');
               $('.popup-form-success').css('display', 'block');
            }
         });
      }
   });

   //$('.wpcf7-form').on('submit', function(event) {
   //  event.preventDefault();
   // let phoneNumber = $(this).find('input[type="tel"]').val();

   // console.log(phoneNumber)
   // });








   [].forEach.call(document.querySelectorAll('input[type="tel"]'), function (input) {
      let keyCode;
      function mask(event) {
         this.parentNode.classList.add("form__group--active");
         event.keyCode && (keyCode = event.keyCode);
         let pos = this.selectionStart;
         if (pos < 3) event.preventDefault()
         let matrix = "+38 (___) ___-__-__",
             i = 0,
             def = matrix.replace(/\D/g, ""),
             val = this.value.replace(/\D/g, ""),
             newValue = matrix.replace(/[_\d]/g, function (a) {
                return i < val.length ? val.charAt(i++) || def.charAt(i) : a;
             });
         i = newValue.indexOf("_");
         if (i != -1) {
            i < 5 && (i = 3);
            newValue = newValue.slice(0, i);
         }
         let reg = matrix.substr(0, this.value.length).replace(/_+/g,
             function (a) {
                return "\\d{1," + a.length + "}";
             }).replace(/[+()]/g, "\\$&");
         reg = new RegExp("^" + reg + "$");
         if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) this.value = newValue;
         if (event.type == "blur" && this.value.length < 5) this.value = "";
      }

      input.addEventListener("input", mask, false);
      input.addEventListener("focus", mask, false);
      input.addEventListener("blur", mask, false);
      input.addEventListener("keydown", mask, false);
      input.addEventListener('mouseup', event => {
         event.preventDefault()
         if (input.value.length < 4) {
            input.setSelectionRange(4, 4)
         } else {
            input.setSelectionRange(input.value.length, input.value.length)
         }
      })
   });

   let lastScroll = 0;
   const header = document.getElementById("sticky-part");


   window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      // Условие: прокрутка вверх и мы не в самом верху страницы
      if (currentScroll < lastScroll && currentScroll > 100) {
         header.classList.add('sticky');
         header.classList.add('is-sticky');
         document.body.classList.add('header-sticky');

      }
      // Условие: прокрутка вниз
      else if (currentScroll > lastScroll && currentScroll > 100) {
         header.classList.remove('sticky');
         header.classList.remove('is-sticky');
         document.body.classList.remove('header-sticky');
      }
      // Если вернулись в самое начало
      else if (currentScroll <= 100) {
         header.classList.remove('sticky');
         header.classList.remove('is-sticky');
         document.body.classList.remove('header-sticky');
      }

      lastScroll = currentScroll;
   });





   $('.seo__show').on('click', function (){
      $('.seo').addClass('seo--show');
   });
   $('.seo__hide').on('click', function (){
      $('.seo').removeClass('seo--show');
   });




   $('.filials-page-grid__more-btn a').on('click', function (){
      $('body').addClass('filials-page-grid-all');
   });






   $('.turbo-popup__close').on('click', function (){
      $('.turbo-popup__show').removeClass('turbo-popup__show');
      $('body').removeClass('popup-show');

   });

   $('.turbo-popup').click(function(event) {
      if (event.target === this) {
         $('.turbo-popup__show').removeClass('turbo-popup__show');
         $('body').removeClass('popup-show');
      }
   });






   FS('#burger-btn').onClick(function (){
      FS('body').addClass('burger__show');
   });

   FS('#burger-btn-close').onClick(function (){
      FS('body').removeClass('burger__show');
   });

   FS('.burger__nav .toggle', 'all').onClick(function (e){
      e.preventDefault();
      this.parentNode.parentNode.classList.toggle('sub-show');
   });




   $('.burger').click(function(event) {
      if (event.target === this) {
         $('body').removeClass('burger__show');
      }
   });




   $('.go-collback').on('click', function (){
      $('body').addClass('collback-show');
   });

   $('.collback__close').on('click', function (){
      $('body').removeClass('collback-show');
   });


   $('.collback').click(function(event) {
      if (event.target === this) {
         $('body').removeClass('collback-show');
      }
   });



   setTimeout(function() {
      let show = getCookie('gift');
      if(show === 'show'){
   }else{
      $('body').addClass('collback-show');
      setCookie('gift', 'show');
   }
   }, 5000);







   $('.home-address__form-title').on('click', function (){
      $(this).parent().toggleClass('home-address__form-title-active');
   });

   $('.home-address__region').on('click', function (){
      let region = $(this).data('region');
      if(region === 'all'){
         $('.home-address__region-filials').removeClass('hidden');
      }else{
         $('.home-address__region-filials').addClass('hidden');
         $(".region-" + region).removeClass('hidden');
      }
      $('.home-address__region-filials-active').removeClass('home-address__region-filials-active');
      $(this).addClass('home-address__region-filials-active');
   });


   $('.home-address__region-filials').on('click', function (){
      let map = $(this).data('filial');
      $(".home-address__region-map-active").removeClass('home-address__region-map-active');
      $(".map-" + map).addClass('home-address__region-map-active');
      $('.home-address__region-filials-active').removeClass('home-address__region-filials-active');
      $(this).addClass('home-address__region-filials-active');
   });








   $('.pw-prices-list__slider').slick({
      slidesToShow: 3, // Default for large screens
      slidesToScroll: 1,
      prevArrow: $('.pw-prices-list__slider-prev'),
      nextArrow: $('.pw-prices-list__slider-next'),
      responsive: [
         {
            breakpoint: 1500, // Screen width of 1024px and below
            settings: {
               slidesToShow: 3,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 1100, // Screen width of 1024px and below
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 600, // Screen width of 1024px and below
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,

            }
         },
      ]
   });














   $('#reviews__slider').slick({
      slidesToShow: 4, // Default for large screens
      slidesToScroll: 1,
      prevArrow: $('.reviews-turbo__arrow-prev'),
      nextArrow: $('.reviews-turbo__arrow-next'),
      responsive: [
         {
            breakpoint: 1100, // Screen width of 1024px and below
            settings: {
               slidesToShow: 4,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 800, // Screen width of 1024px and below
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 600, // Screen width of 1024px and below
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,

            }
         },
      ]
   });




      $('#special__slider').slick({
         slidesToShow: 3, // Default for large screens
         slidesToScroll: 1,
         prevArrow: $('.home-special__arrow-prev'),
         nextArrow: $('.home-special__arrow-next'),
         responsive: [
            {
               breakpoint: 1100, // Screen width of 1024px and below
               settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,

               }
            },
            {
               breakpoint: 800, // Screen width of 1024px and below
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,

               }
            },
            {
               breakpoint: 600, // Screen width of 1024px and below
               settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,

               }
            },
         ]
      });



   const mediaPoint = window.matchMedia("(max-width: 1000px)");


   if (mediaPoint.matches) {

      console.log('match')


      $('#advantages-grid__list').slick({
         slidesToShow: 1, // Default for large screens
         slidesToScroll: 1,
         infinite: false,
         prevArrow: $('.advantages-grid__arrow-prev'),
         nextArrow: $('.advantages-grid__arrow-next'),

      });





   }



   $('.home-instructor__slider').slick({
      slidesToShow: 5, // Default for large screens
      slidesToScroll: 1,
      prevArrow: $('.home-instructor__arrow-prev'),
      nextArrow: $('.home-instructor__arrow-next'),
      responsive: [
         {
            breakpoint: 1500, // Screen width of 1024px and below
            settings: {
               slidesToShow: 4,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 1100, // Screen width of 1024px and below
            settings: {
               slidesToShow: 3,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 860, // Screen width of 1024px and below
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,

            }
         },
         {
            breakpoint: 600, // Screen width of 1024px and below
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,

            }
         },
      ]
   });






   $('.home-faq__list-item').on('click', function (){
      $(this).toggleClass('hidden');
   });









   document.addEventListener('DOMContentLoaded', function () {
      function getQueryParam(param) {
         var urlParams = new URLSearchParams(window.location.search);
         return urlParams.get(param) || '';
      }
      var forms = document.querySelectorAll('form.wpcf7-form');
      forms.forEach(function (form) {
         var uaField = form.querySelector('input[name="user_agent"]');
         if (uaField) uaField.value = navigator.userAgent;
         var referrerField = form.querySelector('input[name="referrer"]');
         if (referrerField) referrerField.value = document.referrer;
         var currentUrlField = form.querySelector('input[name="current_url"]');
         if (currentUrlField) currentUrlField.value = window.location.href;
         var utmSource = form.querySelector('input[name="utm_source"]');
         if (utmSource) utmSource.value = getQueryParam('utm_source');
         var utmMedium = form.querySelector('input[name="utm_medium"]');
         if (utmMedium) utmMedium.value = getQueryParam('utm_medium');
         var utmCampaign = form.querySelector('input[name="utm_campaign"]');
         if (utmCampaign) utmCampaign.value = getQueryParam('utm_campaign');
      });
   });




});

function topFunction() {
   document.body.scrollTop = 0; // For Safari
   document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

function setCookie(name,value) {
   var expires = "";
   let days = 7;
   if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
   }
   document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
   var nameEQ = name + "=";
   var ca = document.cookie.split(';');
   for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
   }
   return null;
}
function eraseCookie(name) {
   document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}




function showPopup(target){
   $('html, body').animate({
      scrollTop: $('[id="adsquiz_site-code_aUvNcLoKfe"]').offset().top
   }, 800); // 800 — швидкість прокрутки в мілісекундах
}